import { connect } from 'react-redux';

import SoftAccountModal from '../../components/SoftAccountModal';
import { setShowModal } from '../../actions/auth';

const _mapStateToProps = ({ status }) => ({
    softAccountEmailStatus: status.softAccountEmailStatus,
});
const _mapDispatchToProps = {
    setShowModal,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(SoftAccountModal);
